// @flow

import styled from 'styled-components';
import { px, mb } from 'styled-components-spacing';

import { StyledCoverMaxWidth, maxWidthWideStyle } from '@components/Wrappers';
import { sectionSpacing } from '@components/Wrappers/styles';
import { styledButton } from '@styles/buttons';
import { fontCopyDefault, fontButtonLinkHighlighted } from '@styles/typography';
import theme from '@theme';

export const StyledCover = styled.div`
  display: flex;
  position: relative;

  margin-left: auto;
  margin-right: auto;

  width: 100%;
  min-height: 584px;

  ${maxWidthWideStyle}
  ${sectionSpacing}
`;

export const StyledGradient = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  ${theme.gradients.linearFadedBlueSoftBlueLTR};
`;

export const StyledContentCover = styled(StyledCoverMaxWidth)`
  display: flex;
  margin: auto;
  flex-direction: column;

  align-items: center;
  justify-content: center;

  ${px(3)}
`;

export const StyledText = styled.p`
  ${fontCopyDefault};
  text-align: center;

  ${mb(4.5)}

  max-width: 590px;
  color: ${theme.colors.white};
`;

export const StyledButton = styled.a`
  ${styledButton}
  ${fontButtonLinkHighlighted}

  font-weight: normal;

  ${theme.shadows.medium}

  min-width: 286px;

  background-color: ${theme.colors.aquaMarine};
  border: none;
`;
